import {Component, Input, OnInit} from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {ValidationHandlerService} from '../validation-handler.service';

@Component({
  selector: 'achoo-textarea',
  templateUrl: './achoo-textarea.component.html',
  styleUrls: ['./achoo-textarea.component.scss']
})
export class AchooTextareaComponent extends AchooInputComponent<any> {

  @Input()
  public numberCol: number;

  constructor(protected validationHandlerService: ValidationHandlerService) {
    super(validationHandlerService);
  }


}



// WEBPACK FOOTER //
// ./src/app/core/achoo-textarea/achoo-textarea.component.ts